import React from "react";
import TkIcon from "./icons/domino/tk_icon";

const Tk = ({item}) => {
    return (
        <TkIcon item={item}/>
    )
}

export default Tk